import { render, staticRenderFns } from "./ClientInvoicesList.vue?vue&type=template&id=6a837f7d"
import script from "./ClientInvoicesList.vue?vue&type=script&lang=js"
export * from "./ClientInvoicesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports